// =============================================================================
// app/src/lib/podeMudarEndereco.ts — quem VÊ os botões de mudar endereço.
//
// O balcão (Venda, Busca, catálogo, a folha "Onde fica") só precisa saber SE
// mostra o "Mudar de lugar" e o "Pôr num lugar"; as ações em si moram em
// lib/acoesDeEndereco.ts e descem junto com o fluxo, sob demanda (lazy).
// Importar as ações no pacote principal fez o empacotador partir o pacote em
// dois (06/10/2026, +5 kB gzip no 4G do balcão) — daí este arquivo à parte.
//
// A régua é a MESMA de useAcoesDeEndereco(): dono e gerente (regra 3). E quem
// nega de verdade continua sendo o banco (exige_papel no corpo das RPCs).
// =============================================================================
import { podeGerenciarCatalogo, useSessao } from './sessao';

export function usePodeMudarEndereco(): boolean {
  return podeGerenciarCatalogo(useSessao().papel);
}
